<ion-card class="py-4 px-4 text-left rounded-1">
  <div *ngIf="!(name==='hospitals' && data['Category']==='Inactive')"  class="font-Poppins flex justify-end items-center space-x-1 text-[#c83131] cursor-pointer">
 <!-- <div  *ngIf="name=='hospitals'">
  <div  (click)="deleteAction(data, $event)" class="font-Poppins flex justify-end items-center space-x-1 text-[#c83131] cursor-pointer">
 </div> -->
  
    <ion-icon  class="text-[#46a83d]" size="small" name="create-outline"></ion-icon>
    <ion-icon (click)="deleteAction(data, $event)" size="small" name="trash-outline"></ion-icon>
  </div>
  <div *ngIf="name==='hospitals'">
    <img *ngIf="data['Category']==='Active'"
    class="px-5 m-[auto]"
    src="/assets/hospital/1.png"
    alt="hospital"
  />
    <img *ngIf="data['Category']==='Inactive'"
    class="px-5 m-[auto]"
    src="/assets/hospital/4.png"
    alt="hospital"
  />
  </div>
  <p *ngFor="let key of keys" class="pt-1 my-1">
    <ion-label>
     {{key}}:
    </ion-label>
    <ion-text>
    {{data[key]}}
    </ion-text>
  </p>
  </ion-card>
